
import { Component } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import { DeviceType, AppModule } from '@/store/modules/app'
import { AppMain, Navbar, Sidebar, BottomTabBar } from './components'
import ResizeMixin from './mixin/resize'

@Component({
  name: 'LayoutSidebar',
  components: {
    AppMain,
    Navbar,
    Sidebar,
    BottomTabBar
  }
})
export default class extends mixins(ResizeMixin) {
  get classObj() {
    return {
      hideSidebar: !this.sidebar.opened,
      openSidebar: this.sidebar.opened,
      withoutAnimation: this.sidebar.withoutAnimation,
      mobile: this.device === DeviceType.Mobile
    }
  }

  handleClickOutside() {
    AppModule.CloseSideBar(false)
  }
}
